import React, { useState } from "react";
import { Modal } from "../UI/Modal/Modal";
import AngleDownIcon from "../../assets/images/arrow.svg";

interface SourceNetwork {
    id: string;
    name: string;
    iconUrl: string;
}

interface SourceNetworkSelectorProps {
    networks: SourceNetwork[];
    selectedNetwork: SourceNetwork;
    onNetworkSelect: (network: SourceNetwork) => void;
    label?: string;
    className?: string;
}

export const SourceNetworkSelector: React.FC<SourceNetworkSelectorProps> = ({
    networks,
    selectedNetwork,
    onNetworkSelect,
    label,
    className = "",
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSelect = (network: SourceNetwork) => {
        onNetworkSelect(network);
        setIsModalOpen(false);
    };

    // If there's only one network, display it as static (no dropdown)
    const showAsDropdown = networks.length > 1;

    return (
        <div className={className}>
            {label && (
                <label className="text-white/40 text-xs block">{label}</label>
            )}

            <div
                onClick={showAsDropdown ? () => setIsModalOpen(true) : undefined}
                className={`border border-dropdownBorder h-[52px] border-box px-4 py-3.5 bg-dropdownBg flex justify-between items-center gap-2.5 ${
                    showAsDropdown ? 'cursor-pointer' : ''
                }`}
            >
                <div className="flex gap-2.5">
                    <img
                        className="w-6 h-6"
                        src={selectedNetwork.iconUrl}
                        alt="network icon"
                    />
                    <span className="text-white text-sm font-medium">
                        {selectedNetwork.name}
                    </span>
                </div>
                {showAsDropdown && (
                    <div className="w-5 h-5 flex items-center justify-center">
                        <img src={AngleDownIcon} alt="AngleDownIcon" />
                    </div>
                )}
            </div>

            {showAsDropdown && (
                <Modal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    title="Destination Network"
                    size="lg"
                    className="w-[520px]"
                >
                    <p className="text-white/40 text-sm text-left">
                        Choose the chain where your ANLOG tokens will arrive after bridging.
                    </p>

                    <div className="flex flex-col gap-2 mt-6 max-h-[200px] custom-scrollbar ">
                        {networks.map((network) => (
                            <div
                                key={network.id}
                                onClick={() => handleSelect(network)}
                                className={`flex gap-2.5 items-center px-4 py-3 h-[56px] cursor-pointer transition-colors  ${
                                    selectedNetwork.id === network.id
                                        ? "   border border-modalInputBorder bg-modalInputBg"
                                        : "bg-dropdownBg border border-transparent"
                                }`}
                            >
                                <img
                                    src={network.iconUrl}
                                    alt="network icon"
                                    className="w-6 h-6"
                                />
                                <span className="text-sm font-mediumtext-white">
                                    {network.name}
                                </span>
                            </div>
                        ))}
                    </div>
                </Modal>
            )}
        </div>
    );
};
